import { Google, Linkedin, Meta, Tiktok, Twitter } from "../assets";

export const LOGO_IMAGES = {
    'Meta':Meta,  
    'Google Ads':Google, 
    'LinkedIn':Linkedin, 
    'Twitter':Twitter, 
    'TikTok':Tiktok
}

